// extracted by mini-css-extract-plugin
export default {"icon":"IconLinks_icon__a6V1j","anchor":"IconLinks_anchor__eV1DY"};